import React, { useState, useEffect } from 'react';
import axios from 'axios';

import {
  Button,
  Form,
  Modal,
} from "react-bootstrap";

const Popup = ({
  row,
  onChange,
  onApplyChanges,
  onCancelChanges,
  open,
}) => {

  const [standards, setStandards] = useState([]);
  const [scores, setScores] = useState([]);
  const [spreadsheetName, setSpreadsheetName] = useState(``);
  const [documentName, setDocumentName] = useState(``);

  const fetchStandard = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}standards`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        },
        params: {
          all: true,
        }
      });

      setStandards(response.data.items);

    } catch (error) {
      alert(error)
    }
  }

  const fetchScore = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}scores`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        },
        params: {
          all: true,
        }
      });

      setScores(response.data.items);

    } catch (error) {
      alert(error)
    }
  }

  useEffect(() => {

    fetchStandard();
    fetchScore();

    return () => {}
  }, [])

  return (
    <Modal
      show={open}
      onHide={onCancelChanges}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>New Instrument Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Standard <span className="text-danger">*</span></Form.Label>
          <Form.Control defaultValue={-1} name="STANDARD_ID" as="select" onChange={onChange}>
            <option value={-1}>Please Select...</option>
            {standards && standards.map((standard, key) => (
              <option key={key} value={standard.STANDARD_ID}>
                {standard.STANDARD_NAME}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group>
          <Form.Label>Name <span className="text-danger">*</span></Form.Label>
          <Form.Control name="INSTRUMENT_NAME" onChange={onChange}/>
        </Form.Group>
        <Form.Group>
          <Form.Label>Score Index:  <span className="text-danger">*</span></Form.Label>
          <Form.Control name="SCORE_ID" as="select" onChange={onChange}>
            <option value={-1}>Please Select...</option>
            {scores && scores.map((score, key) => (
              <option key={key} value={score.SCORE_ID}>
                {score.SCORE_NAME}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group>
            <Form.Label>Form Spreadsheet Template  <span className="text-secondary">(Optional)</span></Form.Label>
            <Form.File
              id="form-file"
              label="Choose File"
              custom
              name='form'
              label={spreadsheetName}
              accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
              onChange={(e) => {
                onChange({target: {
                  name: 'form',
                  value: e.target.files[0]
                }});
                setSpreadsheetName(e.target.files[0].name)
              }}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Report Document Template  <span className="text-danger">*</span></Form.Label>
            <Form.File
              id="report-file"
              label="Choose File"
              custom
              name='report'
              label={documentName}
              accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              onChange={(e) => {
                onChange({target: {
                  name: 'report',
                  value: e.target.files[0]
                }});
                setDocumentName(e.target.files[0].name)
              }}
            />
          </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancelChanges}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onApplyChanges}>Save</Button>
      </Modal.Footer>
    </Modal>
  )
};

export default Popup;